import { render } from "./videoTriggerPlayView.vue?vue&type=template&id=ecf1ef34&scoped=true&ts=true"
import script from "./videoTriggerPlayView.vue?vue&type=script&lang=ts"
export * from "./videoTriggerPlayView.vue?vue&type=script&lang=ts"

import "./videoTriggerPlayView.vue?vue&type=style&index=0&id=ecf1ef34&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecf1ef34"]])

export default __exports__